var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("suppliers.supplier_title") } },
    [
      _c("template", { slot: "pageContent" }, [
        _vm.isSmartphoneOS
          ? _c("div", { attrs: { slot: "fixed" }, slot: "fixed" }, [
              _c(
                "div",
                {
                  staticStyle: {
                    position: "absolute",
                    top: "44px",
                    width: "100%",
                  },
                },
                [
                  _c("cm-messages-filter", {
                    staticClass: "researchfilter",
                    staticStyle: { position: "relative", "z-index": "10" },
                    attrs: {
                      propedServiceId: "8",
                      filterType: "list",
                      mode: this.mode,
                    },
                    on: {
                      applyFilter: function ($event) {
                        return _vm.applyFilter($event)
                      },
                    },
                  }),
                ],
                1
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "listPage", staticStyle: { overflow: "hidden" } },
          [
            false
              ? _c(
                  "b-row",
                  {
                    staticClass:
                      "form-group justify-content-start showLargeScreenOnly",
                  },
                  [
                    _c(
                      "b-col",
                      { attrs: { cols: "1" } },
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "btn",
                            attrs: { disabled: _vm.activateSpinner },
                            on: {
                              click: function ($event) {
                                return _vm.refreshInbox()
                              },
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "fa-light fa-rotate-right",
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "fab-label" }, [
                              _vm._v(_vm._s(_vm.$t("common.rfrsh"))),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { cols: "1", "offset-md": "6" } },
                      [
                        _c(
                          "b-button",
                          {
                            attrs: {
                              variant: "primary",
                              disabled: _vm.activateSpinner,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.extractCSV()
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "fa-light fa-upload" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "fab-label" }, [
                              _vm._v(_vm._s(_vm.$t("common.extract"))),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { md: "12" } },
                  [
                    _c("div", { staticClass: "requestsList" }, [
                      !_vm.isSmartphoneOS
                        ? _c(
                            "div",
                            [
                              _c("cm-messages-filter", {
                                staticClass: "researchfilter",
                                staticStyle: {
                                  position: "relative",
                                  "z-index": "10",
                                },
                                attrs: {
                                  filterType: "list",
                                  mode: this.mode,
                                  randomId: _vm.randomId,
                                  buttonCreateSupplier: "",
                                  propedServiceId: "8",
                                },
                                on: {
                                  refreshInbox: function ($event) {
                                    return _vm.refreshInbox()
                                  },
                                  extractCSV: function ($event) {
                                    return _vm.exportList()
                                  },
                                  applyFilter: function ($event) {
                                    return _vm.applyFilter($event)
                                  },
                                  createSupplier: function ($event) {
                                    return _vm.createSupplier()
                                  },
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isSmartphoneOS
                        ? _c("div", { style: _vm.customMobileLayoutStyle })
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _vm.mode === 1 && _vm.items.length
                      ? _c("b-table", {
                          ref: "tableSuppliersList",
                          staticClass: "mt-3",
                          attrs: {
                            hover: "",
                            fixed: "",
                            items: _vm.items,
                            fields: _vm.fields,
                            "sort-by": _vm.sortField,
                            id: "table" + "-" + _vm.randomString,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "cell(siren)",
                                fn: function (data) {
                                  return [_vm._v(_vm._s(data.value))]
                                },
                              },
                              {
                                key: "cell(social_reason)",
                                fn: function (data) {
                                  return [_vm._v(_vm._s(data.value))]
                                },
                              },
                              {
                                key: "cell(date)",
                                fn: function (data) {
                                  return [_vm._v(_vm._s(data.value))]
                                },
                              },
                              {
                                key: "cell(status_label)",
                                fn: function (data) {
                                  return [_vm._v(_vm._s(data.value))]
                                },
                              },
                              {
                                key: "cell(consult)",
                                fn: function (data) {
                                  return [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "cursor",
                                        on: {
                                          click: function ($event) {
                                            return _vm.seeSupplierDetails(
                                              data.value,
                                              "kycform"
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("u", [
                                          _vm._v(
                                            _vm._s(_vm.$t("common.cnslt"))
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "cell(validate)",
                                fn: function (data) {
                                  return [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "cursor",
                                        on: {
                                          click: function ($event) {
                                            return _vm.seeSupplierDetails(
                                              data.value,
                                              "details"
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("u", [
                                          _vm._v(
                                            _vm._s(_vm.$t("common.validate"))
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1357622316
                          ),
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      { staticClass: "mt-5" },
                      [
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-col",
                              { attrs: { cols: "12" } },
                              [
                                _c("cm-pagination", {
                                  attrs: {
                                    maxResultsByPage:
                                      _vm.paginationObject.maxResults,
                                    firstIndex: _vm.paginationObject.firstIndex,
                                    nbResultsTotal:
                                      _vm.paginationObject.nbResultsTotal,
                                    refreshEvent: _vm.paginationObject.refresh,
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }